import { WbGrid, WbGridCol, WbGridRow, WbText } from '@workbench/react';
import RDivider from '../../Common/RDivider/RDivider';
import EquipmentImageCard from './EquipmentImageCard';
import './EquipmentRenderList.scss';

const COL_SPAN = { 1: 12, 2: 6, 3: 4, 4: 3, 6: 2 };

function DescriptionDivider({ description }) {
	if (!description?.text || !description?.code || description.text === 'N/A') return null;
	return (
		<div className="vimdt-equipment-divider">
			<WbText size="s" strong>{`${description.code} / ${description.text}`}</WbText>
			<RDivider />
		</div>
	);
}

function EquipmentRenderList({ imageList, rowCount = 6 }) {
	if (!imageList?.length) return null;

	const span = COL_SPAN[rowCount] || 2;

	return (
		<WbGrid fullWidth>
			<DescriptionDivider description={imageList[0].description} />
			<WbGridRow>
				{imageList.map((image, index) => (
					<WbGridCol key={`${image.title}-${index}`} mq1={12} mq3={6} mq5={span}>
						<EquipmentImageCard url={image.url} title={image.title} imageType={image.imageType} />
					</WbGridCol>
				))}
			</WbGridRow>
		</WbGrid>
	);
}

export default EquipmentRenderList;
